const selectors = {
  imageGallery: "image-gallery",
  carouselCloseBtn: "carousel-close-button",
  video: "video-component",
  imageWrapper: "image-wrapper",
  videoWrapper: "video-wrapper",
  galleryToggleBtn: "gallery-toggle-button",
};

export default selectors;
